import { Card, CardContent, Typography, Box } from "@mui/material";

interface StatsCardProps {
  title: string;
  value: string | number;
  change?: string;
}

const StatsCard = ({ title, value, change }: StatsCardProps) => {
  return (
    <Card
      sx={{
        background: "#ffffff",
        borderRadius: 4,
        color: "#000000",
        // boxShadow: "0 8px 10px #00000040",
      }}
      elevation={0}
    >
      <CardContent>
        <Box
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"space-between"}
          sx={{ height: "100%" }}
        >
          <Typography gutterBottom sx={{ color: "GrayText" }}>
            {title}
          </Typography>
          <Box
            display="flex"
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignContent={"center"}
          >
            <Typography style={{ fontWeight: "bold" }}>
              {value.toLocaleString("en-US")}
            </Typography>

            <Typography sx={{ color: "#569C05", fontSize: "1rem" }}>
              {change !== undefined && change !== null && Number(change) > 0
                ? ` +${change}`
                : ""}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatsCard;
